import { KeyValueModel } from "model";
import { EnumTpNf } from "model/enums/enum-tp-nf";

export const TpNFMock: KeyValueModel[] = [
    new KeyValueModel(EnumTpNf.ENTRADA, 'Entrada'),
    new KeyValueModel(EnumTpNf.SAIDA, 'Saída'),
]